import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { commercialPaper } from "../responseApi";
import ColumnGroupingTable from "../../../table/ColumnGroupingTable.component";
import { useHedgeRatioContext } from "../../../../context/HedgeRatioContext";
import { applyFigureFormatting } from "../../../../utils/utils";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const CommercialPaperTable = () => {
  const { selectedFigureDivisor, selectedDecimalsIn } = useHedgeRatioContext();
  const columns = [
    {
      label: "Commercial Paper",
      children: [
        {
          id: "name",
          label: "Name",
          minWidth: 140,
        },
        {
          id: "value",
          label: "Value",
          minWidth: 140,
          align: "right",
        },
      ],
    },
  ];

  const commercialPaperRows = useMemo(() => {
    return (
      commercialPaper?.map(({ name, value }) => ({
        name,
        value: applyFigureFormatting(
          value,
          selectedFigureDivisor,
          selectedDecimalsIn
        ),
        minWidth: 120,
        align: "left",
        cellStyles: {
          fontWeight: "bold",
          backgroundColor: "#F5F5F5",
          borderTop: "1px solid #000000",
          borderBottom: "1px solid #000000",
        },
      })) || []
    );
  }, [selectedFigureDivisor, selectedDecimalsIn]);

  const datas = commercialPaperRows;

  return (
    <Grid container spacing={2} sx={{ marginBottom: 0 }}>
      <Grid item xs={12} md={12} lg={12}>
        {!commercialPaper ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              There was an error in fetching the data. Please try again later.
            </Typography>
          </Item>
        ) : !commercialPaper?.length ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              No data available for the selected filters.
            </Typography>
          </Item>
        ) : (
          // Commercial Paper
          <ColumnGroupingTable
            columns={columns}
            datas={datas}
            loading={false}
            disablePagination={true}
            applyThousandsSeparator={true}
            tableHeight={108}
            hideChildRowHeader
          />
        )}
      </Grid>
    </Grid>
  );
};

export default CommercialPaperTable;
